const SPECIAL_CHARS_REGEX = /[!@#$%^&*()_+\-=[\]{}|;':",./<>?]/;

export interface PasswordPolicyRuleResult {
  key: string;
  labelKey: string;
  isValid: boolean;
}

export interface PasswordPolicyResult {
  rules: PasswordPolicyRuleResult[];
  isValid: boolean;
}

/**
 * Mirrors the backend password policy for live client-side feedback.
 * The backend remains the source of truth; these rules are server-configurable defaults.
 */
export function validatePasswordPolicy(password: string): PasswordPolicyResult {
  const rules: PasswordPolicyRuleResult[] = [
    { key: 'length', labelKey: 'f-password-policy-length', isValid: password.length >= 8 && password.length <= 128 },
    { key: 'uppercase', labelKey: 'f-password-policy-uppercase', isValid: /[A-Z]/.test(password) },
    { key: 'digit', labelKey: 'f-password-policy-digit', isValid: /[0-9]/.test(password) },
    { key: 'specialChar', labelKey: 'f-password-policy-special-char', isValid: SPECIAL_CHARS_REGEX.test(password) }
  ];

  return { rules, isValid: rules.every((rule) => rule.isValid) };
}
